import React, { useEffect } from "react";
import { ReactComponent as Logo } from '../../assets/Logo2.svg';
import signImg from "../../assets/icons/sign.png";
import dayjs from 'dayjs';
import Helper from "../../services/helper";
import { LazyLoadImage } from "react-lazy-load-image-component";

const SIGNATURE_B64 = "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";
let signImg64 = '';
const convertImage = async () => {
      try {
        // 1. Fetch the local image file
        const response = await fetch(signImg);
        
        // 2. Convert response to a Blob
        const blob = await response.blob();
        
        // 3. Use FileReader to convert Blob to Base64
        const reader = new FileReader();
        reader.onloadend = () => {
          signImg64 = reader.result; // result includes "data:image/png;base64,..."
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error converting image:", error);
      }
    };

const clauses = [
  "We guarantee that the Licensed Music does not infringe on any third-party's intellectual property rights.",
  "In exchange for your Subscription Fee, we grant you this License on a non-exclusive basis.",
  "You are granted the right to use the Licensed Music in this Production and monetize your Production.",
  "You are responsible for generating a license for your Production on our website. If you comply with this License, you are granted the right, worldwide and perpetually, to monetize and commercially exploit your Production. If you do not generate a license for your Production, we cannot distinguish between a licensed and unlicensed use and thus reserve the right to monetize any unlicensed use of our Music on YouTube and/or other channels.",
  "YouTube and other distribution channels do not always maintain accurate and up-to-date copyright information. If you ever receive a copyright claim for our licensed music, please send this License to the claimant and copy us at support@syncmama.com; we will remove the claim without delay. You may also use the YouTube Claim Release functionality in your Project page.",
  "This License does not transfer ownership of our Music to you.",
  "This License does not allow you to create derivative works from the Licensed Music unless authorized by us in writing.",
  "This License does not include the right to collect the public performance and the mechanical royalties of the Licensed Music; these are subject to the rights of the relevant Copyright Societies having jurisdiction in any part of the Territory.",
  "You accept that this License will be void if you, or the licensed Production, violate applicable legislation, if the information given is incorrect, or if you breach any of our terms and conditions.",
  "This License is governed by Indian law, and Mumbai courts have exclusive jurisdiction.",
];

const defs = [
  `<b>"Licensor"</b> means Silk Road Communications Private Limited, a company incorporated under the laws of India [CIN], having its registered office at [address].`,
  `<b>"SyncMama"</b> means the digital sync licensing platform operated by the Licensor at www.syncmama.com.`,
  `<b>"Licensed Music"</b> means the musical work(s) and/or sound recording(s) identified in the Licence Summary generated at the time of this transaction.`,
  `<b>"Production"</b> means the audiovisual work identified by the Licensee in the Licence Summary.`,
  `<b>"Licensee"</b> means the individual or entity accepting this Licence, as identified in the Licence Summary.`,
  `<b>"Subscription Fee"</b> means the fee paid by the Licensee to the Licensor in accordance with the applicable SyncMama subscription plan.`,
  `<b>"Licence Summary"</b> means the transaction record generated by SyncMama at the time of licensing, which forms part of this Licence and sets out the Licensed Music, the Production, the Licensee, and the date of issue.`

];

const terms = [
  `<b>Warranty:</b> The Licensor warrants and represents that, to the best of its knowledge, the Licensed Music does not infringe any third party’s intellectual property rights.`,
  `<b>Grant:</b> In consideration of the Subscription Fee, the Licensor grants the Licensee a non-exclusive licence to synchronise the Licensed Music with the Production, on the terms set out herein. This Licence is issued automatically by the Licensor through the SyncMama platform upon the Licensee’s acceptance of these terms. No separate execution by the Licensor is required.`,
  `<b>Scope of Rights:</b> The Licensor grants the Licensee the right to synchronise the Licensed Music with the Production and to commercially exploit the Production across all media and formats, whether now known or hereafter devised, including but not limited to theatrical, broadcast, OTT, online, and advertising distribution.`,
  `<b>Licence Generation and Compliance:</b> The Licensee must generate a Licence for each Production through the SyncMama platform prior to any distribution or public communication of the Production. Upon compliance with this Licence, the Licensee is granted a worldwide, perpetual right to commercially exploit the Production. Any use of the Licensor’s music in a production for which no Licence has been generated constitutes unlicensed use, and the Licensor reserves the right to claim, monetise, or block such use on YouTube and/or any other distribution platform.`,
  `<b>Copyright Claims:</b> YouTube and other distribution channels do not always maintain accurate or up-to-date copyright information. If the Licensee receives a copyright claim in respect of the Licensed Music, the Licensee shall forward this Licence to the claimant and notify the Licensor at support@syncmama.com. The Licensor will use reasonable efforts to resolve the claim within five (5) business days.`,
  `<b>No Transfer of Ownership:</b> This Licence does not transfer ownership of the Licensed Music to the Licensee.`,
  `<b>No Alteration of Licensed Music:</b> This Licence does not authorise the Licensee to remix, re-record, sample, re-arrange, or otherwise alter the Licensed Music, except as necessary to synchronise it with the Production, including editing for duration and fade.`,
  `<b>Public Performance and Mechanical Royalties:</b> This Licence does not include the right to collect the public performance or mechanical royalties of the Licensed Music. These remain subject to collection by the applicable Collective Management Organisations in each territory. The Licensee acknowledges that the payment of public performance royalties in connection with the exploitation of the Production is the responsibility of the Licensee or the relevant broadcaster or platform, as applicable.`,
  `<b>Termination:</b> The Licensor reserves the right to terminate this Licence if the Licensee or the Production violates applicable law, if the information provided by the Licensee is materially inaccurate, or if the Licensee breaches any of these terms. Upon termination, the Licensee shall cease all exploitation of the Production incorporating the Licensed Music.`,
  `<b>Governing Law and Jurisdiction:</b> This Licence is governed by the laws of India. The courts of Mumbai shall have exclusive jurisdiction over any dispute arising out of or in connection with this Licence.`,

]

export default function SyncMamaLicense(props) {
  // console.log("new lic : ", props)
  const lic = props;
  
  useEffect(() => {
    (async() =>{
      await convertImage();
    })()
  },[])

  // const tracksHTML = lic.tracks?.map((t, i) => {
  //   const info = Helper.sanitizeAndCreateJSON(t.copyrightInfo);

  //   return `
  //     <table width="100%" style="margin-top:10px; font-size:10px; border-collapse:collapse;">
  //       <tr>
  //         <td width="30" style="color:#E40186; font-weight:bold;">
  //           ${String(i+1).padStart(2,'0')}
  //         </td>
  //         <td style="font-weight:bold;">
  //           ${info.DisplayTitle || ''}
  //         </td>
  //         <td align="right" style="color:#E40186;">
  //           ${info.Length || ''}
  //         </td>
  //       </tr>

  //       <tr>
  //         <td colspan="2" style="font-size:10px; color:#666; padding-top:4px;">
  //           Authors: ${info.Composers || ''}<br/>
  //           Publisher: ${info.Publishers || ''}<br/>
  //           ISRC: ${info.ISRC || ''}
  //         </td>

  //         <td style="font-size:10px; color:#666; padding-top:4px;">
  //           ISWC: ${info.ISWC || ''}<br/>
  //           Label: ${info.Labels || ''}
  //         </td>
  //       </tr>
  //     </table>
  //   `;
  // }).join('');

  const tracksHTML = lic.tracks?.map((t, i) => {
    const info = Helper.sanitizeAndCreateJSON(t.copyrightInfo);

    return `
      <table width="500px" style="margin-top:10px; font-size:10px; border-collapse:collapse; table-layout:fixed;">
        
        <tr>
          <td style="color:#E40186; font-weight:bold; width:10px;">
            ${String(i+1).padStart(2,'0')}
          </td>

          <td style="font-weight:bold; overflow:hidden; white-space:nowrap; text-overflow:ellipsis; width:180px;">
            ${info.DisplayTitle || ''}
          </td>

          <td style="font-weight:bold; text-align:right; width:80px;">
            <span style="color:#E40186;"> ${t.duration || ''}</span>
            <span style="color:#666; font-size:10px;">Sec</span>
          </td>
        </tr>

        <tr>
          <td style="width:10px;"/>
          <td style="font-size:10px; color:#666; padding-top:4px; width:180px;">
            <b>Authors:</b>&nbsp; ${info.Composers || ''}<br/>
            <b>Publisher:</b>&nbsp; ${info.Publishers || ''}<br/>
            <b>Label:</b>&nbsp; ${info.Labels || ''}
          </td>

          <td style="font-size:10px; color:#666; padding-top:4px; width:200px;">
            <b>ISWC:</b>&nbsp; ${info.ISWC || ''}<br/>
            <b>ISRC:</b>&nbsp; ${info.ISRC || ''}
          </td>
        </tr>

      </table>
    `;
  }).join('');

  const clausesHTML = clauses.map((c, i) => `
    <div style="font-size:10px;">
      <b style="color:#E40186; margin-bottom:1px">${i+1}.</b> ${c}
    </div>
  `).join('');

  const defsHtml = defs.map(e => `
    <div style="font-size:10px; margin-bottom:1px;">
       ${e}
    </div>
  `).join('');
  const termsHTML = terms.map((t, i) => `
    <div style="font-size:10px;">
      <b style="color:#E40186; margin-bottom:1px">${i+1}.</b> ${t}
    </div>
  `).join('');
  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#fff", minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700;800&display=swap" rel="stylesheet" />
      <div style={{width:"800px", margin:"10px"}}>

        {/* <!-- HEADER --> */}
        <table cellspacing="0" cellpadding="0" style={{background:"#E40186",color:"#fff"}}>
          <colgroup>
            <col style={{width:"220px"}} />
            <col style={{width:"300px"}} />
          </colgroup>
          <tr>
            <td style={{padding:"4px",fontWeight:"bold",fontSize:"22px"}}>
              SyncMama
            </td>
            <td style={{textAlign:"right",padding:"4px", paddingRight:"10px",fontSize:"10px", verticalAlign: "bottom"}}>
              A Silk Road Communications Platform
            </td>
          </tr>
        </table>

        {/* <!-- TITLE --> */}
        <div style={{paddingBottom:"10px"}}>
          <div style={{fontSize:"20px",fontWeight:"bold", paddingLeft: "4px"}}>
            MUSIC SYNCHRONIZATION LICENSE
          </div>
          <div style={{width:"60px",height:"3px",background:"#E40186",marginTop:"6px"}}></div>
        </div>

        {/* <!-- META --> */}
        <table cellpadding="10" style={{background:"#FFF0F8", marginBottom:"10px"}}>
          <colgroup>
            <col style={{width:"220px"}} />
            <col style={{width:"200px"}} />
            <col style={{width:"100px"}} />
          </colgroup>
          <tr>
            <td>
              <div style={{fontSize:"10px",color:"#666"}}>License No.</div>
              <div style={{fontWeight:"bold",fontSize:"10px"}}>{lic.licenseDetails.licenseNumber}</div>
            </td>
            <td>
              <div style={{fontSize:"10px",color:"#666"}}>License Date</div>
              <div style={{fontWeight:"bold",fontSize:"10px"}}>{dayjs(lic.licenseDetails.createdAt).format('DD.MM.YYYY')}</div>
            </td>
            <td>
              <div style={{fontSize:"10px",color:"#666"}}>Status</div>
              <div style={{fontSize:"10px",color:"#E40186",fontWeight:"bold"}}>ACTIVE</div>
            </td>
          </tr>
        </table>

        {/* <!-- LICENSOR --> */}
        <div style={{paddingBottom:"10px"}}>
          <div style={{color:"#E40186",fontSize:"10px",fontWeight:"bold"}}>LICENSOR</div>
          <div style={{height:"1px",background:"#E40186",marginTop:"4px"}}></div>

          <div style={{marginTop:"6px",fontSize:"10px"}}>
            <b>Silk Road Communications Private Limited</b><br/>
            1307, Solus, Central Avenue, Hiranandani Estate, Thane, Maharashtra — 400607
          </div>
        </div>

        {/* <!-- LICENSEE --> */}
        <div style={{paddingBottom:"10px"}}>
          <div style={{color:"#E40186",fontSize:"10px",fontWeight:"bold"}}>LICENSEE</div>
          <div style={{height:"1px",background:"#E40186",marginTop:"4px"}}></div>

          <div style={{marginTop:"6px",fontSize:"10px"}}>
            <b>{lic.licenseDetails.licensee?.first_name}</b><br/>
            {lic.licenseDetails.licensee?.companyAddress} &nbsp;|&nbsp; {lic.licenseDetails.licensee?.taxNumber}
          </div>
        </div>

        {/* <!-- USAGE --> */}
        <div style={{paddingBottom:"10px"}}>
          <div style={{color:"#E40186",fontSize:"10px",fontWeight:"bold"}}>LICENSED USAGE</div>
          <div style={{height:"1px",background:"#E40186",marginTop:"4px"}}></div>

          <table width="100%" style={{marginTop:"8px",fontSize:"10px"}}>
            <tr><td width="150"><b>Production</b></td><td>{lic.licenseDetails?.project?.title}</td></tr>
            <tr><td><b>Distribution</b></td><td>{lic.licenseDetails.distributionChannel?.includes("{") && lic.licenseDetails.distributionChannel?.includes("[")
                 ? <div className="w-9/12 pb-1 ">{props.getChannels(JSON.parse(lic.licenseDetails.distributionChannel))}</div> 
                 : <div className="w-9/12 pb-1 ">{lic.licenseDetails?.distributionChannel}</div>
                 
                }</td></tr>
            <tr><td><b>Total Duration</b></td><td>{lic.licenseDetails?.totalDuration}</td></tr>
            <tr><td><b>Music Used</b></td><td>{lic.licenseDetails?.musicDuration}</td></tr>
            <tr><td><b>Release Date</b></td><td>{lic.licenseDetails?.releaseDate}</td></tr>
          </table>
        </div>

        {/* <!-- RIGHTS --> */}
        <div style={{paddingBottom:"10px"}}>
          <div style={{background:"#FFF0F8",padding:"10px"}}>
            <div style={{fontSize:"10px",color:"#666"}}><b>Licensed Rights</b></div>
            <div style={{fontSize:"10px"}}>
              The right to synchronize the Works with this Production and distribute worldwide.
            </div>
          </div>
        </div>

        {/* <!-- TRACKS --> */}
        <div style={{paddingBottom:"10px"}}>
          <div style={{color:"#E40186",fontSize:"10px",fontWeight:"bold"}}>LICENSED WORKS</div>
          <div style={{height:"1px",background:"#E40186",marginTop:"4px"}}></div>

          <div dangerouslySetInnerHTML={{ __html: tracksHTML }} />
        
        </div>

        {/* <!-- FOOTER --> */}
        {/* <table width="500px" style={{background:"#666",color:"#fff",marginTop:"20px"}}>
          <colgroup>
            <col style={{width:"250px"}} />
            <col style={{width:"250px"}} />
          </colgroup>
          <tr>
            <td style={{padding:"10px",fontSize:"11px"}}>syncmama.com</td>
            <td style={{textAlign:"right",padding:"10px",fontSize:"11px"}}>
              Page 1 of 2<br/>
              support@syncmama.com
            </td>
          </tr>
        </table> */}

      </div>

      {/* <!-- PAGE BREAK --> */}
      <div style={{pageBreakBefore: "always"}}></div>
      {/* <div style="page-break-before: always;"></div> */}
      <br /><br /><br />
      {/* <!-- PAGE 2 --> */}
      <div style={{width:"800px", margin:"10px"}}>

        {/* <!-- HEADER --> */}
        {/* <table width="100%" style={{background:"#E40186",color:"#fff"}}>
          <tr>
            <td style={{padding:"10px 20px",fontWeight:"bold"}}>SyncMama</td>
            <td style={{textAlign:"right",padding:"10px 20px",fontSize:"11px"}}>
              Standard Terms
            </td>
          </tr>
        </table> */}
        <div style={{paddingBottom:"10px"}}>
          <div style={{color:"#E40186",fontSize:"10px",fontWeight:"bold"}}>DEFINITIONS</div>
          <div style={{height:"1px",background:"#E40186",marginTop:"4px"}}></div>

          <div style={{marginTop:"10px",lineHeight:"1.6", width:"510px", marginBottom:"10px"}}>
            <div dangerouslySetInnerHTML={{ __html: defsHtml }} />
          </div>
        </div>
        <div style={{paddingBottom:"10px"}}>
          <div style={{color:"#E40186",fontSize:"10px",fontWeight:"bold"}}>LICENCE TERMS</div>
          <div style={{height:"1px",background:"#E40186",marginTop:"4px"}}></div>

          <div style={{marginTop:"10px",lineHeight:"1.6", width:"510px", marginBottom:"10px"}}>
            <div dangerouslySetInnerHTML={{ __html: termsHTML }} />
          </div>
        </div>
        <div style={{height:"1px",background:"#E40186",marginTop:"4px"}}></div>


        <div style={{paddingBottom:"10px"}}>
          {/* <div style={{fontSize:"18px",fontWeight:"bold"}}>STANDARD TERMS</div>
          <div style={{width:"50px",height:"3px",background:"#E40186",marginTop:"6px"}}></div>

          <div style={{marginTop:"15px",lineHeight:"1.6", width:"510px", marginBottom:"10px",borderBottom:"1px solid #020202"}}>
            <div dangerouslySetInnerHTML={{ __html: clausesHTML }} />
          </div> */}
          <div style={{marginTop:"15px",lineHeight:"1.6", width:"510px", marginBottom:"10px"}}>
            <div style={{fontSize:"10px"}}>This Licence, together with the Licence Summary, constitutes the entire agreement between the Licensor and the Licensee in respect of the synchronisation of the Licensed Music with the Production.</div>
          </div>
          {/* <div style={{marginTop:"30px", paddingBottom:"10px"}}>
            <img src={`${signImg64}`} alt={"Signature"} width={"100px"}/>
            <div style={{borderTop:"1px solid #020202",marginTop:"6px",paddingTop:"6px",fontSize:"11px"}}>
              For and on behalf of the Licensor<br/>
              <b>Silk Road Communications Private Limited</b>
            </div>
          </div> */}

        </div>

        {/* <!-- FOOTER --> */}
        <table style={{background:"#666",color:"#fff"}}>
          <colgroup>
            <col style={{width:"260px"}} />
            <col style={{width:"250px"}} />
          </colgroup>
          <tr>
            <td style={{padding:"4px",fontSize:"10px"}}>syncmama.com</td>
            <td style={{textAlign:"right",padding:"4px",fontSize:"10px"}}>
              {/* Page 2 of 2<br/> */}
              support@syncmama.com
            </td>
          </tr>
        </table>

      </div>
    </div>
  );
}

